
import { Header } from "./Header";
import { Toaster } from "@/components/ui/toaster";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

export function Layout({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation();
  
  // Handle iOS fullscreen mode
  useEffect(() => {
    // Attempt to scroll 1px to hide the address bar on page load
    const hideAddressBar = () => {
      if (!document.documentElement.scrollTop) {
        window.scrollTo(0, 1);
      }
    };
    
    // Run after page load
    window.addEventListener('load', hideAddressBar);
    // Run after orientation changes and resize events
    window.addEventListener('resize', hideAddressBar);
    
    // Initial attempt
    setTimeout(hideAddressBar, 0);
    
    return () => {
      window.removeEventListener('load', hideAddressBar);
      window.removeEventListener('resize', hideAddressBar);
    };
  }, []);
  
  return (
    <div className="min-h-screen flex flex-col pt-safe pb-safe pl-safe pr-safe">
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <footer className="border-t py-6 md:py-8">
        <div className="container flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} SakuWari. {t('common.allRightsReserved', 'All rights reserved')}.
          </p>
          <div className="flex items-center space-x-4">
            <a href="/blog" className="text-sm text-muted-foreground hover:text-primary">{t('blog.title', 'Blog')}</a>
            <a href="/privacy" className="text-sm text-muted-foreground hover:text-primary">{t('common.privacy', 'Privacy')}</a>
            <a href="/terms" className="text-sm text-muted-foreground hover:text-primary">{t('common.terms', 'Terms')}</a>
          </div>
        </div>
      </footer>
      <Toaster />
    </div>
  );
}
